import * as React from 'react';

const Input = ({ label, type, value, required, onChange, onBlur, className, tooltip, min, pattern, disabled = false, icon, onClick, maxLength }) => {
  return (
    <label className={`${className} label-input ${icon ? 'input-icon' : ''}`}>
      {icon &&
        <i onClick={onClick} className="material-symbols-outlined input-material-icons">{icon}</i>
      }
      {tooltip &&
        <em className="app-tooltip">
          <i className="material-symbols-outlined">info</i>
          <div className="app-tooltipwrapper">{tooltip}</div>
        </em>}
      <input onChange={onChange} onBlur={onBlur} pattern={pattern} type={type} placeholder=" " maxLength={maxLength} min={min} value={value} disabled={disabled} />
      {label && (
        <span>{label}{required && (<em className='req'>*</em>)}</span>
      )}
    </label>
  );
}

export default Input;

